import { render, staticRenderFns } from "./cMenu.vue?vue&type=template&id=c4dc36f0&scoped=true"
import script from "./cMenu.vue?vue&type=script&lang=js"
export * from "./cMenu.vue?vue&type=script&lang=js"
import style0 from "./cMenu.vue?vue&type=style&index=0&id=c4dc36f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4dc36f0",
  null
  
)

export default component.exports